import React, {PureComponent} from 'react'
import injectSheet from 'react-jss'
import ImageOrVideo from "../Widgets/ImageOrVideo"
import Heading from "../Widgets/Heading"
import AuthorAndShareLinks from "./AuthorAndShareLinks"
import RichTextContainer from "../Widgets/RichTextContainer"
import CategoryLabelAndTime from "../Widgets/CategoryLabelAndTime"
import Subtitle from "../Widgets/Subtitle"
import CentredContentContainer from "../Widgets/CentredContentContainer"
import theme from "../../styles/theme"

const MAX_IMAGE_WIDTH = 534;

class VerticalHero extends PureComponent {

    render() {
        const {classes, article, images, isMobile} = this.props;
        const {title, sub_title, author, details} = article;
        const video = article.video_mobile_vertical && isMobile ? article.video_mobile_vertical : article.video_vertical;

        return (
            <CentredContentContainer data-cy="verticalHeroContainer">
                <div className={classes.container}>
                    <div className={classes.leftColumn} data-cy="verticalHeroLeftColumn">
                        <ImageOrVideo key={video ? video.id : "image"} className={classes.image} images={images} video={video} />
                    </div>
                    <div className={classes.rightColumn} data-cy="verticalHeroRightColumn">
                        <div className={classes.authorMeta} data-cy="verticalHeroContent">
                            <CategoryLabelAndTime article={article} className={classes.categoryContainer} />
                            <Heading classes={classes}>{title}</Heading>
                            {sub_title && <Subtitle classes={classes} className="normalVerticalFlow">{sub_title}</Subtitle> }
                            <AuthorAndShareLinks author={author} article={article} hideArticleLength={true} />
                        </div>
                        {details && <RichTextContainer className={classes.content} content={details} removeBottomMargin={true}></RichTextContainer>}
                    </div>
                </div>
            </CentredContentContainer>
        );
    }
}

export default injectSheet({
    container: {
        display: "flex",
        flexDirection: 'column',
        margin: 0,
        [theme.breakpoint("tablet")]: {
            margin: '54px 0',
            flexDirection: 'row'
        }
    },
    header: {
        textTransform: 'initial'
    },
    subTitle: {
        margin: '8px 0 16px 0',
        ...theme.font.subtitle
    },
    categoryContainer: {
        justifyContent: 'center',
        [theme.breakpoint("tablet")]: {
            justifyContent: 'left'
        }
    },
    authorMeta: {
        margin: '40px 0',
        maxWidth: theme.content.width,
        width: '100%',
        marginLeft: 'auto',
        marginRight: 'auto',
        order: 0,
        [theme.breakpoint("tablet")]: {
            margin: details => details ? '0 0 40px 0' : '0',
            maxWidth: 'none',
            width: 'auto',
            marginLeft: 0,
            marginRight: 0
        }
    },
    leftColumn: {
        verticalAlign: "top",
        display: "inline-block",
        width: "100%",
        order: 1,
        [theme.breakpoint("tablet")]: {
            width: "49%",
            order: 0
        }
    },
    rightColumn: {
        display: "contents",
        flexDirection: "column",
        width: "100%",
        maxWidth: theme.content.width,
        marginLeft: "auto",
        marginRight: "auto",
        textAlign: 'center',
        paddingLeft: 0,
        [theme.breakpoint("tablet")]: {
            display: "flex",
            width: "49%",
            textAlign: 'left',
            paddingLeft: '2%',
            justifyContent: 'center',
            order: 1
        }
    },
    image: {
        maxWidth: "100%",
        marginRight: 0,
        marginLeft: 'auto',
        marginTop: 0,
        marginBottom: 30,
        [theme.breakpoint("tablet")]: {
            maxWidth: MAX_IMAGE_WIDTH,
            marginBottom: 0
        }
    },
    content: {
        paddingBottom: '1rem',
        textAlign: 'left',
        order: 2,
        [theme.breakpoint("tablet")]: {
            paddingBottom: '2rem',
            order: 1
        },
    },
    topMarginless: {
        marginTop: '0 !important',
    },
    bottomMarginless: {
        marginBottom: '0 !important',
    },
    type: {
        display: "inline-table",
        transform: "rotate(-90deg) translateX(-100%)",
        transformOrigin: "left top 0",
        margin: `${theme.spacing.normal} 0 0 -${theme.spacing.normal}`,
    }
})(VerticalHero)



// WEBPACK FOOTER //
// ./src/components/Article/VerticalHero.js